export default {
  getSupplyHistory: {
    method: 'post',
    url: '/supply/history/list'
  }
}
